






import { Component, Vue } from 'vue-property-decorator';
import TemplateCreateModuleForm from './components/templateCreateModuleForm.vue';
import { templateListInstance } from '@/model/ModuleTemplateListClass';

@Component({
  components: {
    TemplateCreateModuleForm,
  },
})
export default class CreateModuleFromTemplate extends Vue {
  private templateListInstance = templateListInstance;
  get template() {
    return this.templateListInstance.moduleTemplate;
  }
}
